var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text",class:{'rich-text__full-screen': _vm.$$FormData.full_screen},style:({
    backgroundColor: _vm.$$FormData.background_color
  }),domProps:{"innerHTML":_vm._s(_vm.$$FormData.content || _vm.default_content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }